import request from '@/utils/request'

export const login = params =>
  request({
    url: '/manage/login/index',
    method: 'post',
    data: params,
    noToken: true
  })

export const logout = params =>
  request({
    url: '/manage/login/logout',
    method: 'post',
    data: params
  })

export const serviceList = params =>
  request({
    url: '/manage/article/index',
    method: 'post',
    data: params
  })

export const serviceEdit = params =>
  request({
    url: '/manage/article/edit',
    method: 'post',
    data: params
  })

export const exportExcel1 = params =>
  request({
    url: '/manage/article/derive',
    // responseType: 'blob', //  配置数据类型
    method: 'post',
    data: params
  })

// 服务列表删除
export const serviceDel = params =>
  request({
    url: '/manage/article/del',
    method: 'post',
    data: params
  })

export const userAdd = params =>
  request({
    url: '/manage/manage/add',
    method: 'post',
    data: params
  })

export const userList = params =>
  request({
    url: '/manage/manage/index',
    method: 'post',
    data: params
  })

// 用户删除
export const userDel = params =>
  request({
    url: '/manage/manage/del',
    method: 'post',
    data: params
  })

// 用户编辑
export const userEdit = params =>
  request({
    url: '/manage/manage/edit',
    method: 'post',
    data: params
  })

// 图片上传
export const uploadImgs = params =>
  request({
    url: '/api/file/upload',
    method: 'post',
    noToken: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: params
  })

// 图片上传（指定目录）
export const uploadOssImgs = params =>
  request({
    url: '/api/file/upload_oss',
    method: 'post',
    noToken: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: params
  })

/** 护工下拉（订单指/改派、新项目订单等）：默认无参，与 ChangeOrderNurseInfo 一致；部分场景可传 body 扩展字段 */
export const fetchNurseList = params =>
  request({
    url: '/manage/nurses/index',
    method: 'post',
    data: params || {}
  })
export const fetchHospitalList = params =>
  request({
    url: '/manage/orders/hospital_lists',
    method: 'post',
    data: params
  })
export const exportHospitalList = params => {
  return request({
    url: '/manage/orders/hospital_export',
    method: 'post',
    data: params
  })
}
export const fetchFosterList = params =>
  request({
    url: '/manage/orders/dis_lists',
    method: 'post',
    data: params
  })

export const fetchFosterRecordList = (params, extra) =>
  request({
    url: '/manage/orders/dis_record_lists',
    method: 'post',
    data: params,
    ...(extra || {})
  })
export const fetchNurseServices = params =>
  request({
    url: '/api/nurse_services/item',
    method: 'post',
    data: params
  })

export const fetchOrderList = params =>
  request({
    url: '/manage/orders/lists',
    method: 'post',
    data: params
  })
export const fetchOrderDetailById = params =>
  request({
    url: '/manage/orders/detail',
    method: 'post',
    data: params
  })
export const delOrderById = params =>
  request({
    url: '/manage/orders/delete',
    method: 'post',
    data: params
  })

export const delOrderServiceById = params =>
  request({
    url: '/manage/orders/delete_record',
    method: 'post',
    data: params
  })

export const editOrderUserInfoById = params =>
  request({
    url: '/manage/orders/edit_userinfo',
    method: 'post',
    data: params
  })

export const allocateOrderInfoById = params =>
  request({
    url: '/manage/orders/allocate',
    method: 'post',
    data: params
  })

export const batchAllocateOrderInfo = params =>
  request({
    url: '/manage/orders/batch_allocate',
    method: 'post',
    data: params
  })

export const cancelOrderById = params =>
  request({
    url: '/manage/orders/cancel',
    method: 'post',
    data: params
  })
export const auditOrderCancelById = params =>
  request({
    url: '/manage/orders/verify_refund',
    method: 'post',
    data: params
  })

export const fetchFinancialList = params =>
  request({
    url: '/manage/statistics/cash_flow',
    method: 'post',
    data: params
  })

export const addNurse = params =>
  request({
    url: '/manage/nurses/add',
    method: 'post',
    data: params
  })

export const editNurse = params =>
  request({
    url: '/manage/nurses/edit',
    method: 'post',
    data: params
  })

export const fetchNurseAddressList = params =>
  request({
    url: '/manage/nurses/address',
    method: 'post',
    data: params
  })

export const fetchNurseSList = params =>
  request({
    url: '/manage/nurses/lists',
    method: 'post',
    data: params
  })
export const fetchCouponList = params =>
  request({
    url: '/manage/coupon',
    method: 'post',
    data: params
  })

export const addCoupon = params =>
  request({
    url: '/manage/coupon/add',
    method: 'post',
    data: params
  })

export const fetchCouponDetail = params =>
  request({
    url: '/manage/coupon/info',
    method: 'post',
    data: params
  })

export const sendCoupon = params =>
  request({
    url: '/manage/coupon/send',
    method: 'post',
    data: params
  })

export const fetchDashboardSummary = (params, extra) =>
  request({
    url: '/manage/dashboard/summary',
    method: 'post',
    data: params || {},
    ...(extra || {})
  })

export const fetchDashboardRecord = (params, extra) =>
  request({
    url: '/manage/dashboard/record',
    method: 'post',
    data: params || {},
    ...(extra || {})
  })

export const fetchDashboardTfStat = (params, extra) =>
  request({
    url: '/manage/dashboard/tf_stat',
    method: 'post',
    data: params || {},
    ...(extra || {})
  })

export const fetchStatisticsOrderQuantity = (params, extra) =>
  request({
    url: '/manage/statistics/order_quantity',
    method: 'post',
    data: params,
    ...(extra || {})
  })

export const fetchStatisticsOrderYmw = (params, extra) =>
  request({
    url: '/manage/statistics/order_ymw',
    method: 'post',
    data: params,
    ...(extra || {})
  })
export const fetchStatisticsOrderCancel = params =>
  request({
    url: '/manage/statistics/order_cancel',
    method: 'post',
    data: params
  })

export const fetchStatisticsOrderPieChart = params =>
  request({
    url: '/manage/statistics/order_pie_chart',
    method: 'post',
    data: params
  })

export const fetchRolesList = params =>
  request({
    url: '/manage/manage/roles',
    method: 'post',
    data: params
  })

export const editUsrRoles = params =>
  request({
    url: '/manage/manage/edit',
    method: 'post',
    data: params
  })

export const fetchHospitalManageList = params =>
  request({
    url: '/manage/hospital/lists',
    method: 'post',
    data: params
  })

export const fetchOrderNoticeList = params =>
  request({
    url: '/manage/notices/lists',
    method: 'post',
    data: params
  })

export const getOrderNoticeUrl = params =>
  request({
    url: '/manage/notices/add',
    method: 'post',
    data: params
  })
export const delOrderNotice = params =>
  request({
    url: '/manage/notices/del',
    method: 'post',
    data: params
  })

export const editHospital = params =>
  request({
    url: '/manage/hospital/edit',
    method: 'post',
    data: params
  })

export const fetchNurseServicesList = params =>
  request({
    url: '/api/nurse_services/index',
    method: 'post',
    data: params
  })

export const insertHospital = params =>
  request({
    url: '/manage/hospital/add',
    method: 'post',
    data: params
  })

export const fetchHospitalPList = params =>
  request({
    url: '/wx/hospital/lists',
    method: 'post',
    data: params
  })

export const insertOrder = params =>
  request({
    url: '/manage/orders/create',
    method: 'post',
    data: params
  })

export const updateOrder = params =>
  request({
    url: '/manage/orders/edit',
    method: 'post',
    data: params
  })

// 特殊服务
export const destituteLists = params =>
  request({
    url: '/manage/orders/destitute_lists',
    method: 'post',
    data: params
  })
// 服务列表删除
export const destituteDel = params =>
  request({
    url: '/manage/orders/delete',
    method: 'post',
    data: params
  })

export const destituteDetail = params =>
  request({
    url: '/manage/orders/destitute_detail',
    method: 'post',
    data: params
  })

export const destituteAllocate = params =>
  request({
    url: '/manage/orders/allocate',
    method: 'post',
    data: params
  })

export const destituteLeave = params =>
  request({
    url: '/manage/orders/leave',
    method: 'post',
    data: params
  })

export const destituteExport = params => {
  return request({
    url: '/manage/orders/destitute_export',
    method: 'post',
    data: params
  })
}
export const fetchStationList = params => {
  return request({
    url: '/manage/station/lists',
    method: 'post',
    data: params
  })
}

export const changeStatusForStation = params =>
  request({
    url: '/manage/station/status',
    method: 'post',
    data: params
  })

export const stationInsert = params =>
  request({
    url: '/manage/station/add',
    method: 'post',
    data: params
  })

export const stationEdit = params =>
  request({
    url: '/manage/station/edit',
    method: 'post',
    data: params
  })

export const stationDetail = params =>
  request({
    url: '/manage/station/detail',
    method: 'post',
    data: params
  })

export const apiArticleInfo = params =>
  request({
    url: '/api/article/info',
    method: 'post',
    data: params
  })

// 民政局文件上传
export const stationImport = params =>
  request({
    url: '/api/file/import',
    method: 'post',
    noToken: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: params
  })

// ---------- 新项目订单 orders_sn（后端需实现对应接口）----------
export const fetchOrdersSnList = params =>
  request({
    url: '/manage/orders/disabled_lists',
    method: 'post',
    data: params
  })

/** 失能/新项目订单列表导出，与 disabled_lists 筛选参数一致 */
export const exportOrdersSn = params => {
  return request({
    url: '/manage/orders/disabled_export',
    method: 'post',
    data: params
  })
}

export const fetchOrdersSnDetail = params =>
  request({
    url: '/manage/orders/disabled_detail',
    method: 'post',
    data: params
  })

export const delDeleteDisRecord = params =>
  request({
    url: '/manage/orders/delete_dis_record',
    method: 'post',
    data: params
  })

/** 失能/新项目订单表格导入：multipart 与 Apifox 一致 — file、body[region]（由调用方 append）、head[token]（拦截器） */
export const importOrdersSn = formData => {
  return request({
    url: '/manage/orders/disabled_import',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]'
  })
}

/** 返回模板下载地址（与导出接口相同，data 为可下载 URL） */
export const fetchOrdersSnImportTemplate = () =>
  request({
    url: '/manage/orders_sn/import_template',
    method: 'post',
    data: {}
  })

/** 失能护理：修改护理记录 */
export const editNurseDailyRecord = params =>
  request({
    url: '/manage/nurses/edit_daily_record',
    method: 'post',
    data: params
  })
export const fetchArticleServices = params =>
  request({
    url: '/api/article/items',
    method: 'post',
    data: params
  })

/** 寄宿托养：服务内容项（服务记录用） */
export const fetchCriArticleServices = params =>
  request({
    url: '/api/article/cri',
    method: 'get',
    noToken: true,
    params: {
      ...(params || {}),
      'head[token]': sessionStorage.getItem('AuthToken') || ''
    }
  })

export const switchStatusLeave = params =>
  request({
    url: '/manage/orders/switch_status',
    method: 'post',
    data: params
  })

/** 探访订单接口 */
export const ordersTfLists = params =>
  request({
    url: '/manage/orders/tf_lists',
    method: 'post',
    data: params
  })
export const importOrdersTf = formData => {
  return request({
    url: '/manage/orders/tf_import',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]'
  })
}
export const fetchOrdersTfDetail = params =>
  request({
    url: '/manage/orders/tf_detail',
    method: 'post',
    data: params
  })
/** 探访记录导出 */
export const exportOrdersTf = params => {
  return request({
    url: '/manage/orders/tf_export',
    method: 'post',
    data: params
  })
}
/** 添加探访记录 */
export const addTfRecord = params =>
  request({
    url: '/manage/nurses/add_tf_record',
    method: 'post',
    data: params
  })
/** 修改探访记录 */
export const editTfRecord = params =>
  request({
    url: '/manage/nurses/edit_tf_record',
    method: 'post',
    data: params
  })
// 图片上传（指定目录）
export const uploadOssTfImg = params =>
  request({
    url: '/api/file/upload_oss_tf',
    method: 'post',
    noToken: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: params
  })

/** 寄宿托养：创建订单 */
export const createBoardingOrder = params => {
  const formData = new FormData()
  const fields = ['cri_type', 'name', 'tel', 'sex', 'id_card', 'dis_grade', 'img_urls', 'address', 'age']
  fields.forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      formData.append(`body[${key}]`, params[key])
    }
  })
  return request({
    url: '/manage/orders/cri_create',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]'
  })
}

/** 寄宿托养：订单列表 */
export const fetchBoardingList = params => {
  const formData = new FormData()
  // last_log_time 与 create_time 相同：单个字段，值为「开始秒,结束秒」
  const singleFields = ['create_time', 'last_log_time', 'cri_type', 'nurse_name_or_tel', 'order_status', 'pageNumber', 'pageSize', 'user_name_or_tel']
  singleFields.forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      formData.append(`body[${key}]`, params[key])
    }
  })
  return request({
    url: '/manage/orders/cri_lists',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]'
  })
}

/** 寄宿托养：订单详情 */
export const fetchBoardingOrderDetail = params => {
  const formData = new FormData()
  const order_id = params && params.order_id
  if (order_id !== undefined && order_id !== null && order_id !== '') {
    formData.append('body[order_id]', order_id)
  }
  return request({
    url: '/manage/orders/cri_detail',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]'
  })
}

/** 寄宿托养：修改被服务人信息 */
export const editBoardingOrderUserInfo = params => {
  const formData = new FormData()
  const fields = ['order_id', 'name', 'tel', 'sex', 'age', 'cri_type', 'id_card', 'dis_grade', 'img_urls', 'address']
  fields.forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      formData.append(`body[${key}]`, params[key])
    }
  })
  return request({
    url: '/manage/orders/cri_edit',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]'
  })
}

/** 寄宿托养：删除服务记录 */
export const delBoardingServiceRecord = record_id => {
  const formData = new FormData()
  if (record_id !== undefined && record_id !== null && record_id !== '') {
    formData.append('body[record_id]', record_id)
  }
  return request({
    url: '/manage/orders/delete_cri_record',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]'
  })
}

/** 寄宿托养：修改服务记录 */
export const editBoardingServiceRecord = params => {
  const formData = new FormData()
  const fields = ['id', 'order_id', 'service_time', 'service_item', 'img_urls', 'attendance']
  fields.forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      formData.append(`body[${key}]`, params[key])
    }
  })
  return request({
    url: '/manage/orders/edit_cri_record',
    method: 'post',
    data: formData,
    multipartTokenField: 'head[token]'
  })
}
